import { render, staticRenderFns } from "./exerciseDetail.vue?vue&type=template&id=1cf379f6&scoped=true&"
import script from "./exerciseDetail.vue?vue&type=script&lang=js&"
export * from "./exerciseDetail.vue?vue&type=script&lang=js&"
import style0 from "./exerciseDetail.vue?vue&type=style&index=0&id=1cf379f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf379f6",
  null
  
)

export default component.exports